export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-05.74d39ac1.jpg";